import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import type { AssignmentsOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import { t } from 'ember-intl'
import { formatValue } from 'teacher-ui-client/utils/format-value'

interface Args {
  isLoading?: boolean
  overviewData: AssignmentsOverviewReportData['overview']
}
interface Signature {
  Args: Args
  Element: HTMLTableElement
}
export const DashboardStudentAssignmentsOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <ThStandard class="w-1/2">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.totalAssignmentsCompleted"}}
        </ThStandard>
        <ThStandard class="w-1/2">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.averageAssignmentScore"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      <tr>
        <td class="p-3">{{formatValue @overviewData.total_assignments_completed}}</td>
        <td class="p-3">
          {{formatValue @overviewData.average_assignment_score append="%"}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

export default DashboardStudentAssignmentsOverview
